module.exports = __webpack_public_path__ + "img/number04.d8ba2907.svg";